<!--<div class="card grid col-md-12 ml-0 mb-3 pt-0  pb-0 " style="display:flex; background-color:white">
    <div class=" col-md-1 ">
        <h5 class="mt-3 pl-3"><strong>{{testName}}:</strong></h5>
    </div>
    <div class="col-md-1 pt-2 pl-70">
    </div>
</div>-->

<p-table *ngIf="labdetails"
         [responsive]="true"
         [columns]="cols"
         [value]="labdetails.data"
         selectionMode="single"
         dataKey="labId"
         [resetPageOnSort]="false"
         [lazy]="false"
         [rows]="rows"
         [paginator]="true">
    <!--<ng-template pTemplate="caption">
          <button pButton type="button" pTooltip="" pTooltipPosition=""
                  style="font-size: 1.2em; " label="&nbsp;" class="ui-button-secondary"
                  ></button>
          <div class="floatin">
              <button pButton type="submit" icon="pi pi-link" label="back" class="p-button-success" (click)="gotoback();"></button>
          </div>
      </ng-template>-->

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-rowData
                 let-columns="columns"
                 let-i="rowIndex">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns">
                <!--   <span class="column-title">{{col.header}}</span>-->
                {{ rowData[col.field] }}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6">No records found</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
        Showing {{ state.page * state.rows + 1 }} to
        {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
    </ng-template>
</p-table>

<div class="card grid col-12 mt-5 ml-0 mb-3"
     style="display: flex; background-color: white">
    <!--<button pButton type="button" pTooltip="" pTooltipPosition="" icon="pi pi-comment"
              style="font-size: 1.2em; " label="Comments" class="ui-button-secondary"></button>-->
    <button pButton
            type="button"
            icon="pi pi-print"
            label="Print"
            class="p-button-plain"
            (click)="printLabComments()"
            title="Print Labs Comments"
            *ngIf="setPrintFlag"></button>&nbsp;<button pButton
                                                        type="button"
                                                        pTooltip=""
                                                        pTooltipPosition=""
                                                        icon="pi pi-comment"
                                                        label="Comments:"
                                                        class="ui-button-secondary"
                                                        style="
      font-size: 1.2em;
      background: #d0d1cdeb;
      color: #212121;
      border-color: transparent;
    "></button>

    <div class="comments pt-2">
         {{ comments }}
    </div>
</div>






<div class="panel table-responsive" id="PrintLabComments_List" style="display: none">
    <div style="display: flex; background-color: #ffffff; margin-bottom: 1.5%; padding: 0.5%;">
        <div style="display: flex;justify-content: left;align-items: center; width: 50%;">
            <span>Labs:&nbsp; {{testName}} </span>
        </div>
    </div>

    <div style="display: flex;align-items: center;justify-content: center;margin: 0;">
        <table style="width: 100%; border-collapse: collapse; border: 1px solid grey">
            <thead style="background-color: #142066;border: 0px solid #808080; color: snow;">
                <tr>
                    <th *ngFor="let col of cols" style="border: 1px solid #808080; text-align: left">
                        {{ col.header }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of labdetails?.data">
                    <td *ngFor="let col of cols" style="text-align: left;border: 1px solid #808080;padding: 0.5%">
                        {{ item[col.field] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div *ngIf="labdetails?.data?.length == 0" class="alert alert-warning" role="alert" style="text-align: center">
        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
        <span class="sr-only">&#9888;</span>
        <i>No records found</i>
    </div>

    <div class="comments pt-2" style="margin-top: 20px; padding: 10px; border-top: 2px dashed #ccc; font-style: italic; background-color: #f9f9f9; color: #333;">
        {{ comments }}
    </div>
</div>

<!--<p-dialog [(visible)]="displaypopup" [draggable]="true" [modal]="true" positionType="absolute"
          [style]="{width: '50vw'}" [baseZIndex]="10000" [maximizable]="true">
    <p-header>
        {{testName}}
    </p-header>


    <div class="grid">
        <div class="col-12 " [innerHTML]="patientnote">

        </div>
    </div>
    <p-footer style="display: flex; justify-content:center">

        <button pButton type="button" icon="pi pi-times-circle" (click)="displaypopup=false" label="Cancel" class="ui-button-secondary"></button>
    </p-footer>
</p-dialog>-->
